import { render, staticRenderFns } from "./DwellingUnitAddressLine.vue?vue&type=template&id=59b2c672&scoped=true"
import script from "./DwellingUnitAddressLine.vue?vue&type=script&lang=js"
export * from "./DwellingUnitAddressLine.vue?vue&type=script&lang=js"
import style0 from "./DwellingUnitAddressLine.vue?vue&type=style&index=0&id=59b2c672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2c672",
  null
  
)

export default component.exports